<template>
  <div class="mdl-grid">
    <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"></div>
    <header class="cover mdl-cell mdl-cell--8-col">
      <div class="card-cover mdl-card mdl-shadow--2dp">
        <div class="mdl-card__media"
          :style="{ background: 'url(' + tree.inmueble.imagen + ') center / cover' }"></div>
        <div :class="['mdl-card__title', promedio ? ( promedio >= tree.inmueble.aceptable ? 'bg-green' : ( promedio > tree.inmueble.inaceptable ? 'bg-yellow' : 'bg-red' )) : 'bg-grey']">
          <div class="mdl-card__title_1">
            <div class="mdl-card__title-media">
              <img :src="tree.unidadNegocio.imagen">
            </div>
            <h2 class="mdl-card__title-text">
              <strong>{{ tree.inmueble.nombre }}</strong>
              <span>{{ tree.empresa.nombre }}</span>
            </h2>
          </div>
          <div class="mdl-card__title_2">
            <div class="mdl-card__helper">
              <strong>{{ tree.inmueble.incidencias }}</strong>
              <small>Incidencias</small>
            </div>
            <div class="mdl-card__helper">
              <strong>{{ promedio ? promedio : 'N / A' }}</strong>
              <small>Puntos</small>
            </div>
            <div class="mdl-card__helper">
              <small>{{ tree.inmueble.status || 'AUDITANDO' }}</small>
            </div>
          </div>
        </div>
        <div v-for="responsable in tree.inmueble.mantenimiento" class="mdl-card__supporting-text">
          <div class="minilogo" :style="{backgroundImage: 'url(' + responsable.avatar + ')' }"></div>
          <!-- <img class="avatar"
                src=""
                alt="Imagen del Encargado de Mantenimiento"> -->
          <div class="flex-grow-2">
            <strong>{{ responsable.nombre }}</strong>
            <span>Responsable de Mantenimiento</span>
          </div>
          <div>
            <!-- <span>{{ responsable.since }}</span> -->
          </div>
        </div>
      </div>
    </header>
    <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"></div>
    <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"></div>
    <main class="events mdl-cell mdl-cell--8-col">
      <div class="card-event mdl-card mdl-shadow--2dp"
        v-for="(d, i) in data"
        :key="i">
        <div :class="['mdl-card__title', 'mdl-card--expand',
                     d.promedio ? (
                       d.promedio >= d.aceptable
                          ? 'bg-green'
                          : ( d.promedio > d.inaceptable
                            ? 'bg-yellow'
                            : 'bg-red' )
                      ) : 'bg-grey'
                    ]">
          <h4>
            {{ d.promedio ? d.promedio : 'N / A' }}<br>
            <span>{{ d.nombre }}</span><br>
            <p></p>
          </h4>
        </div>
        <div class="mdl-card__actions mdl-card--border">
          <a class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
            :data-i="i"
            :data-index="index"
            :data-value="d.id"
            :data-text="d.nombre"
            :data-father-id="d.padreId"
            @click="clickEvent">
            Auditar
          </a>
          <div class="mdl-layout-spacer"></div>
          <!-- <i class="material-icons">event</i> -->
        </div>
      </div>
    </main>
    <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"></div>
    <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"></div>
    <footer class="footer mdl-cell mdl-cell--8-col">
      <div class="card-footer mdl-card mdl-shadow--2dp">
        <div class="mdl-card__title">
          <h4 class="mdl-card__title-text">Resumen de Auditoria</h4>
        </div>
        <div class="mdl-card__supporting-text">
          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <textarea v-model="tree.inmueble.resumen" @blur="guardarTree"
              class="mdl-textfield__input" type="text" rows= "3"></textarea>
            <label class="mdl-textfield__label">Escribe el resumen de la auditoría aquí...</label>
          </div>
        </div>
        <div class="mdl-card__actions mdl-card--border" hidden>
          <a class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            Get Started
          </a>
        </div>
        <div class="mdl-card__menu">
          <!-- <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect">
            <i class="material-icons">refresh</i>
          </button> -->
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  props: ['tree', 'data', 'childData', 'index', 'clickEvent'],
  data () {
    return {
      readyToSend: false,
      missing: 0,
      promedio: 0,
      actionbar: {
        show: true,
        buttons: [
          {
            text: 'Cancelar',
            onclick: () => {
              this.$dialog.accept = () => {
                this.borrarAuditoriaActiva()
                this.$toast.show('Cancelaste la Auditoría')
              }

              this.$dialog.show('Cancelar Auditoría',
                'Estás a punto de cancelar la auditoría. Se borrarán todas las' +
                ' incidencias que guardaste, ¿deseas continuar?')
            }
          },
          {
            text: 'Enviar',
            onclick: () => {
              if (!this.readyToSend) {
                return this.$toast.show('Favor de evaluar todas las áreas ('+this.missing+').')
              }

              this.$dialog.accept = () => {
                const areas = this.data
                let auditoria = {
                  user_id: this.$user.data.id,
                  inmueble_id: this.tree.inmueble.id,
                  promedio: this.tree.inmueble.promedio,
                  resumen: this.tree.inmueble.resumen,
                  incidencias: []
                }, imagenes = [], promises = []

                if (auditoria.resumen.length === 0) {
                  return this.$toast.show('Favor de escribir tu RESUMEN de la auditoría.')
                }

                areas.forEach(area => {
                  promises.push(
                    this.$idb.keyVal.getOnly('rubros', 'padreId', area.id)
                    .then(rubros => {
                        rubros.forEach(rubro => {
                          rubro.especificaciones.forEach(especificacion => {
                            auditoria.incidencias.push({
                              ponderacion_id: especificacion.selected.id,
                              imagenes: especificacion.imagenes,
                              observaciones: especificacion.observaciones
                            })

                            /*imagenes.push({
                              ponderacion_id: especificacion.selected.id,
                              data: especificacion.imagenes,
                            })*/
                        })
                      })
                    })
                  )
                })

                Promise.all(promises).then(() => {
                  // console.log(auditoria, imagenes)

                  this.$http.post('auditoria/all', auditoria).then(response => {
                    return !response || response.data.status !== 'OK'
                      ? Promise.reject('¡Algo sucedió! Porfavor vuelve a intentar guardar la auditoría.')
                      : Promise.resolve(response.data)
                  }).then(response => {
                    if (response.status === 'OK') {
                      // Enviar notificacion.
                      this.$http.post('auditoria/notify', {
                        type: 'nueva-auditoria',
                        username: this.$user.data.name,
                        inmueble: this.tree.inmueble.nombre
                      }).then(response => {
                        console.log(response)
                      })

                      this.$toast.show('¡Auditoría guardada con éxito!')
                      this.borrarAuditoriaActiva()
                      this.$router.push('/')
                      this.$loading.hide()
                      // this.$http.post('incidencias/new2', auditoria).then(response => {
                    }
                  }, rejectMsg => {
                      this.$toast.show(rejectMsg)
                      this.$loading.hide()
                  })
                })

                /* Old way de almacenar auditoria e incidencias...
                this.$http.post('auditoria/new', auditoria).then(response => {
                  return !response || response.data.status !== 'OK'
                    ? Promise.reject('¡Algo sucedió! Porfavor vuelve a intentar guardar la auditoría.')
                    : Promise.resolve(response.data)
                  }).then(data => {
                    let promises = []
                    areas.forEach(area => {
                      let send = {
                        incidencias: []
                      }

                      promises.push(
                        this.$idb.keyVal.getOnly('rubros', 'padreId', area.id).then(rubros => {
                        rubros.forEach(rubro => {
                          rubro.especificaciones.forEach(especificacion => {
                            let incidencia = {
                              ponderacion_id: especificacion.selected.id,
                              imagenes: especificacion.imagenes,
                              observaciones: especificacion.observaciones
                            }

                            send.incidencias.push(incidencia)
                          })
                        })
                          }).then(() => {
                            return this.$http.post('incidencia/new/' + data.auditoria_id, send)
                              .then(response => {
                                return response.data.status === 'OK'
                                  ? Promise.resolve()
                                  : Promise.reject('No se logró guardar una incidencia.')
                              })
                          })
                      )
                    })

                    Promise.all(promises).then(() => {
                      // enviar push notification a los jefes.
                      this.$http.post('auditoria/notify', {
                        type: 'nueva-auditoria',
                        username: this.$user.data.name,
                        inmueble: this.tree.inmueble.nombre
                      }).then(response => {
                        console.log(response)
                      })

                      this.borrarAuditoriaActiva()
                      this.$toast.show('¡Auditoría guardada con éxito!')
                      this.$router.push('/')
                    }, () => {
                      this.$toast.show('¡Algo sucedió! Porfavor vuelve a intentar guardar la auditoría.')
                    }).then(() => {
                      this.$loading.hide()
                    })
                  }, rejectMsg => {
                      this.$toast.show(rejectMsg)
                      this.$loading.hide()
                  })*/

                this.$loading.show()
                this.$toast.show('Enviando auditoría...')
              }

              this.$dialog.show('Enviar Auditoría',
                'Estás a punto de enviar la auditoría para su revisión, ¿deseas continuar?')
            },
            disabled: false
          }
        ]
      }
    }
  },
  methods: {
    borrarAuditoriaActiva () {
      this.$idb.keyVal.getOnly('inmuebles', 'id', this.tree.inmueble.id).then(inmuebles => {
        inmuebles.forEach(inmueble => {
          inmueble.activo = 0
          inmueble.promedio = 0
          inmueble.incidencias = 0
          this.$idb.keyVal.set('inmuebles', undefined, inmueble)

          this.$idb.keyVal.getOnly('areas', 'padreId', inmueble.id).then(areas => {
            areas.forEach(area => {
              area.puntos = 0
              area.promedio = 0
              area.incidencias = 0
              this.$idb.keyVal.set('areas', undefined, area)

              this.$idb.keyVal.getOnly('rubros', 'padreId', area.id).then(rubros => {
                rubros.forEach(rubro => {
                  rubro.promedio = 0
                  rubro.puntos = 0
                  rubro.incidencias = 0
                  rubro.especificaciones.forEach(especificacion => {
                    especificacion.imagenes = []
                    especificacion.selected = {
                      id: especificacion.ponderaciones[0].id,
                      color: especificacion.ponderaciones[0].color,
                      valor: especificacion.ponderaciones[0].valor
                    }
                    especificacion.observaciones = ''
                  })
                  this.$idb.keyVal.set('rubros', undefined, rubro)
                })
              })
            })
          })
        })
      })

      this.$emit('activeAudit', false)
      this.$emit('goBack', -1)
      this.$actionbar.destroy()
    },
    calcularPromedio () {
      let self = this,
          promises = [],
          areas = this.data,
          puntosInmueble = 0,
          areasConPromedio = 0,
          incidenciasInmueble = 0

      areas.forEach(area => {
        promises.push(self.$idb.keyVal.getOnly('rubros', 'padreId', area.id).then(rubros => {
          if (!rubros.length) return

          // Inicializando los valores.
          area.puntos = 0
          area.incidencias = 0

          // Sumando los promedios de cada rubro de esta area.
          rubros.forEach(rubro => {
            area.puntos += rubro.promedio
            area.incidencias += isNaN(rubro.incidencias) ? 0 : rubro.incidencias
          })

          // Calculando el promedio del area.
          area.promedio = Math.round10( (area.puntos / rubros.length), -2)
          if (area.promedio === 0) return

          // Definiendo los valores que se usaran para calcular el global.
          areasConPromedio += 1
          puntosInmueble += area.promedio
          incidenciasInmueble += area.incidencias

          // Guardamos el area en idb.
          return this.$idb.keyVal.set('areas', undefined, area)
        }))
      })

      // Cuando se cumpla todo el proceso anterior, entonces si haz el siguiente calculo..
      Promise.all(promises).then(() => {
        self.tree.inmueble.promedio = Math.round10( (puntosInmueble / areasConPromedio), -2)
        self.tree.inmueble.incidencias = incidenciasInmueble
        self.missing = areas.length - areasConPromedio
        self.readyToSend = self.missing === 0

        self.guardarTree()
        self.promedio = self.tree.inmueble.promedio
      }, ()=> {
        self.$toast.show('¡Algo sucedió! Porfavor vuelve a guardar los resultados de esa área.')
      })
    },
    guardarTree () {
      this.$emit('saveTree', this.tree)
    }
  },
  watch: {
    data () {
      // console.log(this.data, 'watch')
      this.calcularPromedio()
      this.$actionbar.init(this.actionbar)
    }
  },
  mounted () {
    // console.log(this.data, 'mounted')
    this.calcularPromedio()
    this.$actionbar.init(this.actionbar)
    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-textfield'))
  }
}
</script>

<style lang="css" scoped>
  .mdl-grid {
    width: 100%;
    margin: 0;
  }

  .card-cover {
    width: 100%;
    min-height: 200px;
    color: #fff !important;
    opacity: 1;
  }

  .card-cover .mdl-card__media {
    position: absolute;
    left: 0;
    width: 100%;
    height: 200px;
    background-position-y: 80%;
    -webkit-filter: blur(3px);
    -moz-filter: blur(3px);
    -o-filter: blur(3px);
    -ms-filter: blur(3px);
    filter: blur(3px);
    z-index: -1;
  }

  .card-cover .mdl-card__title {
    height: 200px;
    flex-direction: column;
    background: #bebebe
  }

  .card-cover .mdl-card__title * {
   color: #fff !important;
   opacity: 1;
  }

  .card-cover .mdl-card__title .mdl-card__title_1,
  .card-cover .mdl-card__title .mdl-card__title_2 {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .card-cover .mdl-card__title .mdl-card__title-media {
    margin: 0 10px;
    align-self: flex-end;
  }

  .card-cover .mdl-card__title .mdl-card__title-media img {
    width: 40px;
  }

  .card-cover .mdl-card__title .mdl-card__title-text {
    flex-grow: 2;
    margin-bottom: 10px;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .card-cover .mdl-card__title .mdl-card__title-text > span {
    font-size: 1.25rem;
  }

  .card-cover .mdl-card__title .mdl-card__helper {
    position: relative;
    bottom: -25px;
    min-height: 65px;
    flex-grow: 2;
    margin: 20px;
    margin-bottom: 0;
    padding: 10px;
    border-radius: 5px 5px 0 0;
    align-self: flex-end;
    text-align: center;
    line-height: 1.25;
    opacity: 0.85;
  }

  .card-cover .mdl-card__title .mdl-card__helper strong {
    display: block;
    font-size: 1.5rem;
    font-weight: bolder;
  }

  .card-cover .mdl-card__title .mdl-card__title-text small,
  .card-cover .mdl-card__title .mdl-card__helper small {
    font-size: 0.75rem;
    font-weight: bold;
    text-transform: uppercase;
  }

  .card-cover .mdl-card__supporting-text {
    width: 100%;
    height: auto;
    background: #fff;
    z-index: 1;

    box-sizing: border-box;
    padding: 16px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }

  .card-cover .mdl-card__supporting-text > * {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .card-cover .mdl-card__supporting-text > *:first-child {
    margin-right: 16px;
  }

  .card-cover .mdl-card__supporting-text .minilogo {
    width: 44px;
    height: 44px;
    background-position: unset;
    background-repeat: round;
    /* background-size: 50%; */
    border-radius: 22px;
    background-color: #F5F5F5;
  }

  .card-cover .mdl-card__supporting-text strong {
    font-weight: bold;
  }

  .card-cover .flex-grow-2 {
    flex-grow: 2;
  }

  .events {
    display: flex;
    flex-flow: row wrap;
  }

  .card-event {
    flex-basis: calc(25% - 7.5px);
    height: 228px;
    margin: 0 10px 10px 0;
    background: #fff;
  }

  @media (max-width: 479px) {
    .card-event {
      flex-basis: calc(50% - 5px);
      margin: 0;
      margin-bottom: 10px;
    }
    .card-event:nth-child(even) {
      margin-left: 10px;
    }
  }

  .card-event:nth-child(4n) {
    margin-right: 0;
  }

  .card-event > .mdl-card__actions {
    border-color: rgba(255, 255, 255, 0.2);
  }

  .card-event > .mdl-card__title {
    align-items: flex-start;
  }

  .card-event > .mdl-card__title * {
    color: #fff !important;
  }

  .card-event > .mdl-card__title > h4 {
    margin-top: 0;
  }

  .card-event > .mdl-card__actions {
    display: flex;
    box-sizing:border-box;
    align-items: center;
  }

  .card-event > .mdl-card__actions > .material-icons {
    padding-right: 10px;
  }

  .card-event > .mdl-card__title,
  .card-event > .mdl-card__actions,
  .card-event > .mdl-card__actions > .mdl-button {
    color: #fff;
  }

  .card-footer {
    width: 100%;
    min-height: 120px;
  }

  .card-footer .mdl-card__title-text {
    font-size: 1.5rem;
  }

  .card-footer .mdl-card__supporting-text {
    width: 100%;
    padding: 0 16px;
  }

  .card-footer .mdl-card__supporting-text .mdl-textfield {
    width: inherit;
  }
</style>


// WEBPACK FOOTER //
// Summary.vue?661d99c6